// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".popup-share{width:90%;max-width:400px;right:50%;transform:translate(50%);border-radius:10px}.popup-share__button-icon{font-size:34px}.popup-share__top{top:100px}.popup-share__bottom{bottom:100px}.border-button{border-radius:50%;border:1px solid #004b80}", ""]);
// Exports
module.exports = exports;
